<template>
  <div :class="['wrapper', classes]">

    <!-- Horizontal bar at top. Contains messages, notifications, tasks and user menu -->
    <dash-header :user="user"></dash-header>
    
    <!-- Left side column. contains the logo and sidebar -->
    <sidebar :user="user" />
  
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1>
          {{$route.meta.hyperlink}}
          <small>{{ $route.meta.description }}</small>
        </h1>
        <!-- <ol class="breadcrumb">
          <li>
            <a href="/admin/dashboard">
              <i class="icon ion-home"></i>Home
            </a>
          </li>
          <li class="active">
            <router-link :to="$route.path">
              {{ $route.meta.description }}
            </router-link>
          </li>
          <li v-for="(item, idx) in $route.meta.breadcrumb"  :key="idx">
            <router-link :to="{ name: item.name }">{{ item.meta.description }}</router-link>
          </li>
        </ol> -->
      </section>

      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>      
    </div>
    <!-- /.content-wrapper -->
  
    <!-- Horizontal bar at bottom. Contains copy right -->
    <dash-footer></dash-footer>
  </div>
</template>

<script>
// import faker from 'faker'
import config from '../config'
import api from '../api'
import DashFooter from './layout/DashFooter'
import DashHeader from './layout/DashHeader'
import Sidebar from './layout/Sidebar'
import Breadcrumb from './layout/Breadcrumb'
import 'hideseek'

export default {
  name: 'Admin',
  components: {
    DashFooter,
    DashHeader,
    Sidebar,
    Breadcrumb
  },
  data: function () {
    return {
      // section: 'Dash',
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      }
    }
  },
  computed: {
    user () {
      return {
        displayName: this.$store.state.user.name,
        // avatar: api.getBaseUrl('Account', '/api/Account/GetImage?Id=' + this.$store.state.user.id),
        avatar: api.getBaseUrl('Account', '/image/Account/' + this.$store.state.user.imageUrl),
        roles: ['Role1, Role2'] // [faker.name.jobTitle(), faker.name.jobTitle()]
      }
    }
  }
}
</script>

<style>
.wrapper.fixed_layout .main-header {
  position: fixed;
  width: 100%;
}
.wrapper.fixed_layout .content-wrapper {
  padding-top: 50px;
}
.wrapper.fixed_layout .main-sidebar {
  position: fixed;
  height: 100vh;
}

@media (max-width: 767px) {
  .wrapper.hide_logo .main-header .logo {
    display: none;
  }
}

.logo-mini,
.logo-lg {
  text-align: left;
}
.logo-mini img,
.logo-lg img {
  padding: 0.4em !important;
}

.logo-lg img {
  display: -webkit-inline-box;
  width: 25%;
}

.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}
</style>



// WEBPACK FOOTER //
// Admin.vue?3b0fd137